import { actions } from '@/modules/RapportASigner/store/actions';
import { getters } from '@/modules/RapportASigner/store/getters';
import { mutations } from '@/modules/RapportASigner/store/mutations';
import { state } from '@/modules/RapportASigner/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { RapportASignerState } from './state';

const RapportASignerModule: Module<RapportASignerState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default RapportASignerModule;
export type { RapportASignerState };
